<template>
  <div class="ui container padded vertical">
    <div class="ui very padded segment">
      <Main />
    </div>
  </div>
</template>

<script>
import Main from "./components/pages/Main.vue";

export default {
  components: {
    Main
  }
};
</script>
